import { TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";

export class Book extends Phaser.GameObjects.Sprite {
    id: number;
    onShelf: boolean;

    constructor(scene: Phaser.Scene, ob: TiledGameObject) {
        var id = ob.properties["id"] as number;
        super(scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "book" + id);

        this.id = id;
        this.onShelf = false;

        this.setInteractive({ useHandCursor: true });
        this.scene.input.setDraggable(this);
        this.scene.add.existing(this);

    }

}

export class BookSlot extends Phaser.GameObjects.Zone {
    id: number;
    shelfX: number;

    constructor(scene: Phaser.Scene, ob: TiledGameObject) {
        super(scene, ob.x + ob.width / 2, ob.y + ob.height / 2, ob.width, ob.height);

        this.id = ob.properties["id"] as number;
        this.shelfX = ob.properties["shelfX"] as number;

        this.setRectangleDropZone(this.width, this.height);

        this.scene.add.existing(this);
    }
}



// WEBPACK FOOTER //
// ./src/games/LibrarianGame/objects/Books.ts